import request from "@/utils/request";

export function getFollowingActs() {
  return request({
    url: "/product/participate/collect/list",
    method: "get",
  });
}
